import React from 'react';
import { Box, Rating as MuiRating, RatingProps as MuiRatingProps, Typography } from '@mui/material';
import { getRatingLabelStyles } from './utils';

interface RatingProps extends MuiRatingProps {
  isLabelHidden?: boolean;
}

export const Rating = ({ isLabelHidden = false, ...props }: RatingProps) => {
  return (
    <Box sx={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
      <MuiRating
        {...props}
        sx={{
          '&.MuiRating-root': { gap: '4px' },
          '&.MuiRating-root.MuiRating-sizeLarge': { '& .MuiSvgIcon-root': { width: '48px', height: '48px' } },
        }}
      />
      {!isLabelHidden && (
        <Typography variant="caption" sx={{ ...getRatingLabelStyles(props.size), fontWeight: 600, color: '#475467' }}>
          {props.value}
        </Typography>
      )}
    </Box>
  );
};
